import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

// 根据长链接，生成短链接
export function webGetShortLink(LongUrl,callback){
	let param = {
		LongUrl: LongUrl,
		TermOfValidity: '1-year'
	}
	request({
			method: 'post',
			url: 'link/getShortLink',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}